import { POST_PURCHASE_APP_ENTRY_URL } from "../constants/formConstants";
import appendSearchToUrl from "./appendSearchToUrl";

export const buildPostPurchaseAppEntryUrl = (search = "") =>
  appendSearchToUrl(POST_PURCHASE_APP_ENTRY_URL, search);

export const redirectToPostPurchaseAppEntry = (search = "") => {
  window.location.href = buildPostPurchaseAppEntryUrl(search);
};

